<template>

  <div v-if="loadingForm" class="px-4 py-3">
    <v-progress-linear :indeterminate="true" :color="app.color_name"></v-progress-linear>
  </div>

  <div v-else class="wrapper-profile-customer">
    <v-layout row wrap>
      <v-flex>
        <h2 class="customer-details-title">CUSTOMER DETAILS</h2>

        <div class="card customer-info-wrapper">
          <div class="card-body">
            <div class="test-data history-profile">
              <div  class="fl" style="padding-right:175px">
                  <qrcode :value=customer.phone :options="{ width: 200 }"></qrcode>
                  <!--                <img :src=customer.avatar alt="avatar" width="150" class="img-rounded"/>-->
              </div>
              <div class="fl" style="width:28%;">
                <div><span class="data-profile" style="color: #F08678">Phone: </span><span class="data-profile">{{customer.phone}}</span></div>
                <div><span class="data-profile" style="color: #F08678">Email: </span><span class="data-profile">{{customer.email}}</span></div>
                <div><span class="data-profile" style="color: #F08678">Location: </span><span class="data-profile">{{city}}, {{country}}</span></div>
                <div><span class="data-profile" style="color: #F08678">DOB: </span>&nbsp;<span class="data-profile">{{customer.date_of_birth}}</span></div>
                <div><span class="data-profile" style="color: #F08678">Nationality: </span><span class="data-profile">{{customer.nationality}}</span></div>
                
                <div v-if="customer.gender == 1"><span class="data-profile" style="color: #F08678">Gender: </span><span class="data-profile">Male</span></div>
                <div v-else-if="customer.gender == 2"><span class="data-profile" style="color: #F08678">Gender: </span><span class="data-profile">Female</span></div>
                <div v-else><span class="data-profile" style="color: #F08678">Gender: </span><span class="data-profile">{{customer.gender}}</span></div>                
              </div>
              <div class="fl" style="width:28%;">
                <!--<div><span class="fwb">Name:</span>&nbsp;<span>{{customer.name}}</span></div>-->
                <div><span style="color: #F08678">Client No: </span><span>{{('000000'+customer.id).slice(-6)}}</span></div>
                <div><span style="color: #F08678">Card No: </span><span>{{customer.card_number}}</span></div>
                <div><span style="color: #F08678">Date Joined: </span><span>{{customer.created_at}}</span></div>                
              </div>
              <!--<div class="fl" style="width:25%">
                <div><span class="fwb">DOB:</span>&nbsp;<span>{{customer.date_of_birth}}</span></div>
                <div><span class="fwb">Nationality:</span>&nbsp;<span>{{customer.nationality}}</span></div>
                <div><span class="fwb">Gender:</span>&nbsp;<span>{{customer.gender}}</span></div>
              </div>-->
              <div v-if="[1, 2, 4, 8].includes(role)" class="fl user-edit">
                <div class="icon-info mb-12" @click="dataForm = false; cancelForm = false; redeemForm = false; returnForm = false; returnInfo = false; checkForm('editing')"><i class="fas fa-edit"></i></div>
              </div>
              <div class="clear" style="height:10px"></div>
            </div>
            <div><span class="font-34">{{customer.name}}</span></div>

      <!--<table class="profile-maininfo">
        <thead>
        <tr>
          <th>Available Points</th>
          <th>Balance Points</th>
          <th>Redeemed Points</th>
          <th>Last Active</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{points_earned - points_redeem}}</td>
          <td>{{points_balance}}</td>
          <td>{{points_spent}} </td>
          <td>{{customer.updated_at}}</td>
        </tr>
        </tbody>
      </table>--><!--
      <div class="ft"><span class="fwb">Available Points:</span><span>{{points_earned - points_redeem}}</span></div>
      <div class="ft"><span class="fwb">Balance Points:</span><span>{{points_balance}}</span></div>
      <div class="ft"><span class="fwb">Redeemed Points:</span><span>{{points_redeem}}</span></div>
      <div class="ft"><span class="fwb">Last Active:</span><span>{{customer.updated_at}}</span></div>-->
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex class="pd-bottom-20">
        <div class="card customer-info-program-wrapper">
          <div class="card-body">
            <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
              <template v-for="(program, index) in programs">
              <li class="nav-item">
                <a v-bind:class="{ active: index == 0 }" class="nav-link profile-tabs" id="general_detail_tab" data-toggle="pill" v-bind:href="'#detail_'+program.id">{{program.name}}</a>
              </li><!--
              <li class="nav-item">
                <a class="nav-link" id="activity_detail_tab" data-toggle="pill" href="#activity_detail">Activity</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="portfolio_detail_tab" data-toggle="pill" href="#portfolio_detail">Portfolio</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="settings_detail_tab" data-toggle="pill" href="#settings_detail">Settings</a>
              </li>-->
              </template>
              <li v-if="[1, 2, 4, 8].includes(role)" class="nav-item abs-right-list-first">
                  <button type="button" large @click="redeemForm = false; cancelForm = false; returnForm = false; returnInfo = false; editingForm=false; checkForm('adding')" class="btn btn-success waves-effect waves-light" :disabled="dataForm">
                    {{ $t('Add Points') }}
                  </button>
              </li>
              <li v-if="[1, 2, 4, 8].includes(role)" class="nav-item abs-right-list-second">
                <button type="button" large @click="dataForm = false; cancelForm = false; returnForm = false; editingForm=false; checkForm('redeem')" class="btn btn-warning waves-effect waves-light" :disabled="dataForm || (points_earned + points_redeem)<=0">
                    {{ $t('Redeem Points') }}
                  </button>
                  <div v-if="(points_earned - points_redeem)<=0" class="reason-no-points">(No points available)</div>
              </li>
            </ul>
          </div>
        </div><!--end card-body-->
      </v-flex>
    </v-layout>

    <!--<v-layout row wrap>
      <v-flex xs12 >
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <div class="btn-points-wrapper">
            <div class="fr btn-profile">
              <v-btn large @click="redeemForm = false; cancelForm = false; checkForm('adding')" class="mb-2" :disabled="dataForm">
                {{ $t('Add Points') }}
              </v-btn>
            </div>
            <div class="fr btn-profile">
              <v-btn large @click="dataForm = false; cancelForm = false; checkForm('redeem')" class="mb-2" :disabled="dataForm || (points_earned - points_redeem)<=0">
                {{ $t('Redeem Points') }}
              </v-btn>
              <div v-if="(points_earned - points_redeem)<=0" class="reason-no-points">(No points available)</div>
            </div>
          </div>
        </v-card-actions>
      </v-flex>
    </v-layout>-->
    <div class="tab-content detail-list" id="pills-tabContent">
      <template v-for="(program, index) in programs">
        <div class="tab-pane fade active" v-bind:class="{ show: index == 0 }" v-bind:id="'detail_'+program.id">
          <v-layout row wrap>
            <v-flex xs4 class="pd-right-25">
              <div class="card">
                <div class="card-body height-264">
                  <div class="d-flex justify-content-between">
                    <h2 class="lifetime-word text-navy font-18">Lifetime</h2>
                    <div class="text-right">
                      <v-switch
                            class="elevation-0 text-right"
                            :inset="true"
                            v-model="program.active_program"
                            color="#19CCA3"
                            @change="changeCustomerActive(program.id, program.active_program)"
                            :label="Switch" 
                    > </v-switch>
                    </div>
                  </div>
                  <div class="text-navy font-14"></div>
                  <div class="d-flex justify-content-between">
                    <img src="/images/site/visuals/monthly-re.png" style="z-index: 1" height="75" />
                    <div class="text-right">
                      <h2 class="mt-0 mb-2 font-weight-semibold total_purchase"><span class="currency-symbol">{{program.symbol}}</span>{{(program.total_spend)}}</h2>
                      <h4 class="title-text mb-0 total_purchase_revenue">Revenue</h4> 
                    </div>
                  </div>
                  <div class="d-flex justify-content-between p-3 rounded stats_profile_main">
                    <div class="left-box">
                      <h4 class="mb-1 font-weight-semibold">{{(program.points_earned)}}</h4>
                      <p class="mb-0">Points Earned</p>
                    </div>
                    <div class="right-box">
                      <h4 class=" mb-1 font-weight-semibold">{{(program.points_redeemed)}}</h4>
                      <p class="mb-0">Points Redeemed</p>
                    </div>
                  </div>
                </div><!--end card-body-->
              </div>
            </v-flex>
            <v-flex xs8>
              <v-layout row wrap>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-lock-open bg-soft-warning"></i></div>
                      <h3 class="text-navy">{{program.available_points}}</h3>
                      <h6 class="font-14 text-navy">Available Points</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-lock bg-soft-pink"></i></div>
                      <h3 class="text-navy font-30">{{(program.locked_points)}}</h3>
                      <h6 class="font-14 text-navy">Locked Points</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>
                
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-history bg-soft-primary"></i></div>
                      <h3 class="text-navy">{{program.points_expired}}</h3>
                      <h6 class="font-14 text-navy">Expired Points</h6>
                      <!--<h3 class="text-dark">5 days ago</h3>-->
                    </div><!--end card-body-->
                  </div>
                </v-flex>

                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-hand-holding-usd bg-soft-success"></i></div>
                      <h3 class="text-navy"><span class="currency-symbol">{{program.symbol}}</span> {{(program.discount_balance.toFixed(2))}}</h3>
                      <h6 class="font-14 text-navy">Reward Balance</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>                
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 class="margin-t-35">
              <div class="card">
                <div class="card-body">
                  <h4 class="header-title mt-0 mb-3">Customer History</h4>
                  <div class="table-responsive browser_users">
                    <div v-if="loadingHistory" class="px-4 py-3">
                      <v-progress-linear :indeterminate="true" :color="app.color_name"></v-progress-linear>
                    </div>

                    <v-data-table
                            :headers="headersHistory"
                            :items="program.histories"
                            class="elevation-1 no-mr no-ml"
                            show-expand
                            :single-expand="true"
                            :items-per-page="options.itemsPerPage"
                            @page-count="pageCount = $event"
                            hide-default-footer
                            :page.sync="options.page"
                    >
                      <template v-slot:[`item.points`]="{ item }">
                        <template v-if="item.program_active">
                          {{item.points}}
                        </template>
                        <template v-else>
                          <v-tooltip v-model="show" bottom>
                            <template v-slot:activator="{ on }">
                              0 &nbsp;<v-icon v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>Program inactive at this date</span>
                          </v-tooltip>
                        </template>
                      </template>
                                            
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length"  v-if="item.items.length > 0">
                          <table class="fullwidth">
                            <thead>
                            <tr>
                              <th>Item</th>
                              <th>Category</th>
                              <th>Brand</th>
                              <th>Sku</th>
                              <th>Quantity</th>
                              <th>Total</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tr v-for="(i, idx) in item.items">
                              <td align="left">{{i.name}}</td>
                              <td align="left">
                                <span v-for="(c, idc) in i.categories">
                                  {{c.name}}
                                </span>
                              </td>
                              <td align="left">{{i.brand }}</td>
                              <td align="left">{{i.sku }}</td>
                              <td align="left">{{ i.quantity }}</td>
                              <td align="left">{{ i.pivot.total }}</td>
                              <td v-if="[1, 2, 4, 8].includes(role)" align="left">
                                <a href="#" v-if="i.pivot.status==='add'" @click="returnItems(item, i)">Cancel</a>
                                <span v-if="i.pivot.status=='cancel'">its been Cancelled</span>
                                <span v-if="i.pivot.status=='refund'">its been Returned</span>
                                <a href="#" v-if="i.pivot.status=='cancel' || i.pivot.status=='refund'" @click="returnItemsInfo(item, i)">(i)</a>                                
                              </td>
                            </tr>
                          </table>
                        </td>
                      </template>

                      <template v-slot:item.shopping_value = {item}>
                          <span v-if="item.currency && item.currency.code">{{ item.currency.code }}</span>&nbsp;{{ item.shopping_value }}
                      </template>

                      <template v-slot:item.actions = {item}>
                        <a href="#" @click="removeHistory(item)" v-if="
                        item.event.category!=='signup' &&
                        item.event.category!=='first-purchase' &&
                        item.active!=0 &&
                        !item.first_purchase &&
                        item.items.length === 0">Cancel</a>
                      </template>                    
                        <template v-slot:footer>
                            <v-row>
                                <v-col :cols="8">
                                    <v-spacer></v-spacer>
                                </v-col>
                                <v-col :cols="2">
                                    <v-select
                                        :items="itemsPerPageOptions"
                                        v-model="options.itemsPerPage"
                                        label="Rows per page"
                                    ></v-select>
                                </v-col>
                                <v-col :cols="2">
                                    <v-pagination
                                        v-model="options.page"
                                        :length="pageCount"
                                        :total-visible="7"
                                    ></v-pagination>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>




                  </div><!--end /div-->
                </div><!--end card-body-->
              </div>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>

      <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="editingForm" :dataForm="editingForm" @keydown.esc="editingForm = false">
          <data-form
                  v-if="editingForm && actionPoint==='editing'"
                  v-on:data-list-events="dataListEvents = $event"
                  :model="model"
                  :uuid="uuid"
          ></data-form>
      </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="dataForm" :dataForm="dataForm" @keydown.esc="dataForm = false">
      <data-form v-if="dataForm && actionPoint==='adding'" v-on:data-list-events="dataListEvents=$event" :model="model" :customer_id="customer.id"></data-form>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="redeemForm" :dataForm="redeemForm" @keydown.esc="redeemForm = false">
      <data-form v-if="redeemForm && actionPoint==='redeem'" v-on:data-list-events="dataListEvents=$event" :model="model" :customer_id="customer.id"></data-form>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="cancelForm" :dataForm="cancelForm" @keydown.esc="cancelForm = false">
      <data-form v-if="cancelForm && actionPoint==='deleting'" v-on:data-list-events="dataListEvents=$event" :model="model" :item="currentItem" :customer_id="customer.id"></data-form>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="returnForm" :dataForm="returnForm" @keydown.esc="returnForm = false">
        <v-card>
          <v-card-title>
            <span class="text-h5">Return Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-select
                    :items="quantityArray"
                    :value="itemQuantity"
                    label="Quantity"
                    @change="updateReturnQuantity"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="8">
                  <span>{{ currentItem.name }}</span>
                </v-col>
              </v-row> 
            </v-container>            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="returnForm = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="returnItemsSubmit(currentItem.pivot.history_id, currentItem.pivot.item_id, itemQuantity)"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 590" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="returnInfo" :dataForm="returnInfo" @keydown.esc="returnInfo = false">
      <v-card>
          <v-card-title>
            <span class="text-h5">Return Item Info</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <table class="fullwidth">
                <thead>
                  <tr>
                    <th>Name</th>                    
                    <th>Brand</th>
                    <th>Sku</th>
                    <th>State Date</th>                                      
                  </tr>
                </thead>
                  <tr v-for="(i, idx) in currentItemList">
                    <td align="left">{{i.name}}</td>                   
                    <td align="left">{{i.brand }}</td>
                    <td align="left">{{i.sku }}</td>                    
                    <td align="left">{{i.pivot.updated_at}}</td>
                  </tr>
                </table>
            </v-container>            
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="returnInfo = false"
            >
              Close
            </v-btn>            
          </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        role: this.$auth.user().role,
        model: 'Platform\\Models\\History',
        customer: [],
        city: '',
        country: '',
        history: [],
        points_earned: 0,
        points_redeem: 0,
        points_spent: 0,
        points_balance: 0,
        shopping_value: 0,
        dataListEvents: null,
        redeemForm: false,
        editingForm: false,
        dataForm: false,
        cancelForm: false,
        returnForm: false,
        returnInfo: false,
        currentItem: false,
        currentItemList: false,
        CustomerActive: false,
        quantityArray: [],
        itemQuantity:0,
        settings : {
          dialog_width: false
        },
        loadingForm: true,
        uuid: false,
        staff_creator:{},
        points_available: 0,
        today: new Date(),
        actionPoint: null,
        opened: [],
        loadingHistory: false,
        order: '',
        programs: [],
        headersHistory: [
          { text: 'Time & Date', value: 'created_at' },
          // { text: 'Brand', value: 'location.program.businesses_text' },
          { text: 'Brand', value: 'business.name' },
          { text: 'Store Name', value: 'location.name' },
          { text: 'Staff ID', value: 'staff_id' },
          { text: 'Staff Name', value: 'staff.name' },
          { text: 'Description', value: 'event.name' },
          { text: 'Receipt Ref', value: 'transaction_number' },
          { text: 'Points', value: 'points' },
          { text: 'Amount', value: 'shopping_value' },
          { text: '', value: 'actions' },
        ],
          options: {
              page: 1,
              itemsPerPage: 5,
              filters: []
          },
          pageCount: 0,
          itemsPerPageOptions: [5,10, 25, 50, 75, 100],
      }
    },
    computed: {
      app () {
        return this.$store.getters.app
      },
    },
    mounted() {
      this.uuid = this.$route.params.uuid;
      this.getDataFromApi().then(data => {
        console.log('job done')
      });

    },
    watch: {
      dataListEvents () {
        if (this.dataListEvents.closeDialog) {
          console.log('comes here close Dialog');
          this.dataForm = false;
          this.redeemForm = false;
          this.cancelForm = false;
          this.returnForm = false;
          this.returnInfo = false;
          this.editingForm = false;
        }
        if (this.dataListEvents.reload) {
          console.log('comes here reload');
          this.reloadData()
        }
      }
    },
    methods: {
      changeCustomerActive(id, active){
        var program_active = active;
        axios
          .put('/app/customer/' + this.customer.id + '/program/'+id+'/state/'+ program_active)
          .then(response => {
            this.reloadData();
          });
      },
      toggle(id) {
        console.log(id);
        const index = this.opened.indexOf(id);
        if (index > -1) {
          this.opened.splice(index, 1)
        } else {
          this.opened.push(id)
        }
      },
      checkForm(action){
        this.actionPoint = action;
        switch (action) {
          case 'redeem' :
            this.redeemForm = true;
            this.model = 'Platform\\Models\\Redeem';
            break;
          case 'adding' :
            this.dataForm = true;
            this.model = 'Platform\\Models\\History';
            break;
        case 'editing' :
            this.editingForm = true;
            this.model = 'App\\Customer';
            break;
        }
      },
      orderHistory(column) {
        if (this.order == 'asc') {
          this.order = 'desc';
        } else {
          this.order = 'asc';
        }

        this.history = _.orderBy(this.history, column, this.order);
      },
      isBalance(program, item) {
        let check = false;
        if (program && program.points_expired_months && program.points_valid_date) {
          const day_expired = (moment(item.created_at).add(program.points_expired_months, 'M'));
          const day_valid = (moment(item.created_at).add(program.points_valid_date, 'd'));

          check = !moment().isAfter(day_expired) &&
                  !moment().isAfter(day_valid) &&
                  !item.force_point &&
                  !item.is_redeem &&
                  (item.event && item.event['category'] !== 'signup');
        }

        return (check && item.active);
      },
      isPoint(program, item) {
        let check = false;
        if (program && program.points_expired_months && program.points_valid_date>=0) {
          const day_expired = (moment(item.created_at).add(program.points_expired_months, 'M'));
          const day_valid = (moment(item.created_at).add(program.points_valid_date, 'd'));

          check = (!moment().isAfter(day_expired) && moment().isAfter(day_valid)) ||
                  (item.event && item.event['category'] === 'signup') ||
                  item.force_point ||
                  (item.event && item.event['category'] === 'cancel');
        }

        return check;
      },
      returnItems(history, item) {

        console.log("item",item);
        
        console.log("passou");

        this.dataForm = false;
        this.redeemForm = false;
        this.editingForm = false;
        this.cancelForm = false;
        this.returnForm = true;
        this.returnInfo = false;
        this.actionPoint = 'returning';        
        this.currentItem = item;

        this.itemQuantity = item.quantity;

        this.quantityArray =[];

        for (let i = item.quantity; i > 0; i--)
        {
          this.quantityArray.push(i);
        }     
                
      },
      returnItemsInfo(history, item) {        

        this.dataForm = false;
        this.redeemForm = false;
        this.editingForm = false;
        this.cancelForm = false;
        this.returnForm = false;   
        this.returnInfo = true;     
        this.actionPoint = 'returningInfo';          

        var itemHistoryID = item.pivot.history_id;
        var itemID = item.pivot.item_id;
        var itemStatus = item.pivot.status;

        this.currentItemList=false;

        axios.get('app/history/'+itemHistoryID+'/items/'+itemID+'/'+itemStatus).then(res => {
            if (res.status === 200) {

              this.currentItemList = res.data[0];              
              
            }
        })
        .catch(err => {
          console.log(err.response.data);
          alert('There was an error returning the data.')
        })
        .finally(() =>{          
          that.loading = false
          
        });        

        this.returnInfo = true;
                
      },
      updateReturnQuantity(value)
      {        

        this.itemQuantity = value;
      },
      returnItemsSubmit(historyId, itemId, quantity) {        

        axios.post('app/history_item/return', {
          historyId: historyId,
          itemId: itemId,
          quantity: quantity
        }).then(res => {
          if (res.data.status === 'success') {            
            this.reloadData()
            this.returnForm = false;
            this.returnInfo = false;
            this.$root.$snackbar(this.$t('items_deleted', { items: 1 }))
          }
        }).catch(err => {
          if (err.response.data.status === 'error') {
            this.$root.$snackbar(err.response.data.msg)
            this.reloadData()
          }
        }).finally(() => that.loading = false)
                
      },
      removeHistory(history) {
        this.dataForm = false;
        this.redeemForm = false;
        this.editingForm = false;
        this.cancelForm = true;
        this.returnForm = false;
        this.returnInfo = false;
        this.actionPoint = 'deleting';
        this.model = 'Platform\\Models\\Cancellation';
        this.currentItem = history;
        //this.deleteRecords(history);
      },
      removeItemFromHistory(history, item){
        this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                  if (confirm) {
                    this.loading = true
                    let that = this
                    axios.post('app/history_item/delete', {
                      id: history.id,
                      item: item
                    }).then(res => {
                      if (res.data.status === 'success') {
                        this.reloadData()
                        this.$root.$snackbar(this.$t('items_deleted', { items: 1 }))
                      }
                    }).catch(err => {
                      if (err.response.data.status === 'error') {
                        this.$root.$snackbar(err.response.data.msg)
                        this.reloadData()
                      }
                    }).finally(() => that.loading = false)
                  }
                })
      },
      getDataFromApi() {
        this.loading = true
        return new Promise((resolve, reject) => {
          let that = this;
          axios.get('/app/customer/'+this.uuid).then(res => {
            if (res.status === 200) {
              this.customer = res.data.customer;
              this.customer.date_of_birth = moment(this.customer.date_of_birth).format('MM/DD/YYYY');
              this.customer.created_at = moment(this.customer.created_at).format('MM/DD/YYYY');
              this.city = res.data.city;
              this.country = res.data.country;
              /*this.city = res.data.city;
              this.country = res.data.country;
              this.history = res.data.history;
              this.staff_creator = res.data.staff_creator;
              this.points_earned = res.data.points_earned;
              this.points_balance = res.data.points_balance;
              this.points_redeem = res.data.points_redeem;
              this.points_spent = res.data.points_spent;
              this.shopping_value = res.data.shopping_value;*/
              this.points_earned = _.sumBy(res.data.programs, (program) => {
                return program.points_earned;
              }) || 0;
              this.points_redeem = _.sumBy(res.data.programs, (program) => {
                return program.points_redeem;
              }) || 0;

              this.programs = res.data.programs;
              this.loadingForm = false;
            }
          }).catch(err => console.log(err.response.data)).finally(() => that.loading = false);
        })
      },
      deleteRecords (history_id) {
        this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                  if (confirm) {
                    this.loading = true
                    let that = this
                    axios.post('app/history/delete', {
                      id: history_id
                    }).then(res => {
                      if (res.data.status === 'success') {
                        this.reloadData()
                        this.$root.$snackbar(this.$t('items_deleted', { items: 1 }))
                      }
                    }).catch(err => {
                      if (err.response.data.status === 'error') {
                        this.$root.$snackbar(err.response.data.msg)
                        this.reloadData()
                      }
                    }).finally(() => that.loading = false)
                  }
                })
      },
      reloadData () {
        this.watchPagination = false
        this.loading = true
        this.getDataFromApi()
                .then(data => {
                  this.rows = data.items
                  this.watchPagination = true
                })
      }
    }
  }
</script>

